export default __webpack_public_path__ + "static/2-533db68ac5571fa008fe57916d0584e9.png";